<template>
  <!-- サイドバーエリア -->
  <aside class="l-sidebar">
    <div class="l-sidebar-inner">
      <!-- メインメニュー -->
      <sidebar-list
        name="dashboard"
        icon="home"
        title="ダッシュボード"
        url="/coins-admin/"
        :details="[]"
        :is-current="true"
        :on-link-click="onLinkClick"
      />
      <sidebar-list
        v-show="isSystemAdmin()"
        name="administrator"
        icon=""
        title="管理メニュー"
        :details="[{ title: 'アカウント管理', url: '/coins-admin/account' }]"
        :on-link-click="onLinkClick"
      />
      <sidebar-list
        v-show="!isSystemAdmin()"
        name="delivery"
        icon="delivery"
        title="配信する"
        :details="deliveryMenu"
        :on-link-click="onLinkClick"
      />
      <sidebar-list
        v-show="!isSystemAdmin()"
        name="analysis"
        icon="graph-bar"
        title="分析する"
        :details="analysisMenu"
        :on-link-click="onLinkClick"
      />
      <!-- /メインメニュー -->

      <!-- サブメニュー -->
      <sidebar-sub
        v-show="!isSystemAdmin()"
        :items="subMenuItems()"
        :on-link-click="onLinkClick"
      />
      <!-- /サブメニュー -->
    </div>

    <error-modal
      ref="refPermissionErrorModal"
      :message="permissionErrorMessage"
      :is-active="isPermissionError"
      :on-close-click="onClosePermissionErrorModal"
    />

  </aside>
  <!-- /サイドバーエリア -->
</template>

<script>
import axios from 'axios';
import store from "../../funcs/store.js";
export default {
  data: function () {
    return {
      notifications: null,
      isPermissionError: false,
      isPermissionCheckProcessing: false,
      permissionErrorMessage: ''
    };
  },
  computed: {
    deliveryMenu: function () {
      // ブラウザプッシュ
      if (store.getServiceTypes().includes('2')) {
        let menus = [];
        menus.push({ title: '配信一覧', url: '/coins-admin/message' });
        menus.push({ title: '配信カレンダー', url: '/coins-admin/message/calendar' });
        menus.push({ title: 'RSS', url: '/coins-admin/rss' });
        if (store.getResourceAccessRules()['AB_TEST']) {
          // 一時的に非表示
          // menus.push({ title: 'A/Bテスト配信', url: '/coins-admin/abtest' });
        }
        if (store.getResourceAccessRules()['SCENARIO']) {
          menus.push({ title: 'シナリオ配信', url: '/coins-admin/step' });
        }
        // プランに依らずアカウント機能(USE_REMINDER)が有効な場合のみ表示する
        if (store.getUseReminder()) {
          menus.push({ title: 'リマインダー配信', url: '/coins-admin/reminder/message' });
        }
        // プランに依らずアカウント機能(USE_UNIQUE_KEY_DELIVERY)が有効な場合のみ表示する
        if (store.getResourceAccessRules()['UNIQUE_KEY_DELIVERY']) {
          menus.push({ title: 'ユニークキー配信', url: '/coins-admin/unique-key-message' });
          menus.push({ title: 'ユニークキーリスト', url: '/coins-admin/unique-key-list' });
        }

        return menus;
      } else {
        return [
          { title: '配信一覧', url: '/coins-admin/message' }
        ];
      }
    },
    analysisMenu: function() {
      // ブラウザプッシュ
      if (store.getServiceTypes().includes('2')) {
        let menus = [];
        menus.push({ title: '配信成果の一覧', url: '/coins-admin/analysis' });
        if (store.getResourceAccessRules()['AB_TEST']) {
          // 一時的に非表示
          // menus.push({ title: 'A/Bテスト結果', url: '/coins-admin/abtest/list' });
        }
        if (store.getResourceAccessRules()['SCENARIO']) {
          menus.push({ title: 'シナリオ配信の成果', url: '/coins-admin/step/result-list' });
        }
        if (store.getResourceAccessRules()['CART_RESULT']) {
          menus.push({ title: 'カートプッシュの成果', url: '/coins-admin/cart/result-list' });
        }
        // プランに依らずアカウント機能(USE_REMINDER)が有効な場合のみ表示する
        if (store.getUseReminder()) {
          menus.push({ title: 'リマインダーの成果', url: '/coins-admin/reminder/result-list' });
        }
        // プランに依らずアカウント機能(USE_UNIQUE_KEY_DELIVERY)が有効な場合のみ表示する
        if (store.getResourceAccessRules()['UNIQUE_KEY_DELIVERY']) {
          menus.push({ title: 'ユニークキー配信の成果', url: '/coins-admin/unique-key-message/result' });
        }
        if (store.getUseTrackingTag()) {
          menus.push({ title: 'コンバージョンの成果', url: '/coins-admin/conversion' });
        }
        return menus;
      } else {
        return [
          { title: '配信成果の一覧', url: '/coins-admin/analysis' },
        ];
      }
    }
  },
  methods: {
    isSystemAdminEdit() {
      return store.state.user.isSystemAdminEdit;
    },
    isSystemAdmin() {
      return store.state.user.isSystemAdmin;
    },
    isSiteAdmin() {
      return store.state.user.isSiteAdmin;
    },
    selectedServiceId() {
      return store.state.service.selecteServiceId;
    },
    canUseAbTest: function() {
      return store.state.account.useAbTest;
    },
    canUseTargetReachCount: function() {
      return store.state.account.useTargetReachCount;
    },
    canUseDeliveryCalendar: function() {
      return store.getUseDeliveryCalendar();
    },
    subMenuItems() {
      let items = [];
      if (store.getResourceAccessRules()['DELIVERY_CONDITION']) {
        items.push({ title: '配信条件の作成・変更', url: '/coins-admin/condition', target: '_self' });
        items.push({ title: '配信対象数の確認', url: '/coins-admin/condition/reach-count', target: '_self' });
      }
      if (this.selectedServiceId()) {
        items.push({ title: 'プロジェクト編集', url: '/coins-admin/project/edit/' + this.selectedServiceId(), target: '_self' });

        // ブラウザプッシュ
        if (store.getServiceTypes().includes('2')) {
          items.push({ title: 'ブラウザプッシュタグ設定', url: '/coins-admin/project/tag/' + this.selectedServiceId(), target: '_self' });
          items.push({ title: 'PWA設定', url: '/coins-admin/project/pwa/' + this.selectedServiceId(), target: '_self'});
        }
      }
      items.push({ title: '配信グループ管理', url: '/coins-admin/message-group', target: '_self' });
      if (store.getResourceAccessRules()['CUSTOM_PARAMETER']) {
        items.push({ title: 'カスタムパラメーター管理', url: '/coins-admin/custom-parameter', target: '_self' });
      }
      if (this.selectedServiceId() && (this.isSiteAdmin() || this.isSystemAdminEdit())) {
        items.push({ title: '編集ログ', url: '/coins-admin/action-log', target: '_self' });
      }
      items.push({ title: 'マニュアル', url: 'https://manual.webpush.jp/', target: '_blank' });
      items.push({ title: 'FAQ', url: 'https://faq.webpush.jp/', target: '_blank' });
      return items;
    },
    headerInfoOpen() {
      this.$refs.headerConfig.close();
      this.$refs.headerSite.close();
    },
    headerConfigOpen() {
      this.$refs.headerInfo.close();
      this.$refs.headerSite.close();
    },
    headerSiteOpen() {
      this.$refs.headerConfig.close();
      this.$refs.headerInfo.close();
    },
    onClosePermissionErrorModal() {
      this.isPermissionError = false;
    },
    onLinkClick: function (url) {
      if (this.isPermissionCheckProcessing) {
        return;
      }
      this.isPermissionCheckProcessing = true;
      // パーミッションチェック
      axios.get('/api/permissions/url-access?path=' + encodeURIComponent(url))
        .then((res) => {
          this.isPermissionCheckProcessing = false;
          if (res.data.status === 'OK') {
            location.href = url;
          } else {
            this.isPermissionError = true;
            this.permissionErrorMessage = res.data.message;
          }
        })
        .catch(_error => {
          this.isPermissionCheckProcessing = false;
          this.isPermissionError = true;
          this.permissionErrorMessage = "エラーが発生しました。";
        });
    },
  },
};
</script>
